module.exports = __webpack_public_path__ + "static/media/Info.c8ea12e0.svg";